import { ref } from 'vue'
import type { InventoryItem } from './models'

export type InventoryApi = {
  getInventory: () => Promise<InventoryItem[]>
}

export function useInventory(api: InventoryApi) {
  const items = ref<InventoryItem[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  const load = async () => {
    loading.value = true
    error.value = null
    try {
      items.value = await api.getInventory()
    } catch (e: any) {
      error.value = e.message || 'Unknown error'
    } finally {
      loading.value = false
    }
  }

  return { items, loading, error, load }
}
